import { Controller } from "@hotwired/stimulus"

// "YYYY-MM-DD" de una fecha local. No usar toISOString(): da el día en UTC.
function formatLocalDate(date) {
  const month = String(date.getMonth() + 1).padStart(2, '0')
  const day = String(date.getDate()).padStart(2, '0')
  return `${date.getFullYear()}-${month}-${day}`
}

// Corre la fecha un período para atrás (-1) o para adelante (1). El mensual va al
// día 1: con setMonth, un 31 de marzo menos un mes da 3 de marzo y no cambiaba de mes.
function shiftDate(date, period, direction) {
  if (period === 'daily') {
    return new Date(date.getFullYear(), date.getMonth(), date.getDate() + direction)
  } else if (period === 'weekly') {
    return new Date(date.getFullYear(), date.getMonth(), date.getDate() + 7 * direction)
  }
  return new Date(date.getFullYear(), date.getMonth() + direction, 1)
}

export default class extends Controller {
  static targets = ["overlay"]
  static values = { period: String, currentDate: String }

  connect() {
    this.hideLoading()
    this.isLoading = false
    window.addEventListener('pageshow', this.handlePageShow.bind(this))
  }

  disconnect() {
    window.removeEventListener('pageshow', this.handlePageShow.bind(this))
  }

  handlePageShow() {
    this.hideLoading()
    this.isLoading = false
  }

  changePeriod(event) {
    if (this.isLoading) {
      event.preventDefault()
      return
    }

    this.isLoading = true
    this.showLoading()
    this.keepSpinnerUntilRedirect()
  }

  previousPeriod() {
    if (this.isLoading) return

    this.isLoading = true
    this.showLoading()

    const period = this.periodValue || 'monthly'

    const newUrl = new URL(window.location)
    newUrl.searchParams.set('date', formatLocalDate(shiftDate(this.displayedDate(), period, -1)))
    newUrl.searchParams.set('period', period)

    window.location.href = newUrl.toString()
  }

  nextPeriod() {
    if (this.isLoading) return

    this.isLoading = true
    this.showLoading()

    const period = this.periodValue || 'monthly'

    const newUrl = new URL(window.location)
    newUrl.searchParams.set('date', formatLocalDate(shiftDate(this.displayedDate(), period, 1)))
    newUrl.searchParams.set('period', period)

    window.location.href = newUrl.toString()
  }

  goToToday() {
    if (this.isLoading) return

    this.isLoading = true
    this.showLoading()

    const period = this.periodValue || 'monthly'

    // Sin `date`, el servidor usa hoy en hora de Argentina. El reloj del navegador
    // no sirve: toISOString() da la fecha UTC, que desde las 21:00 ya es mañana.
    const newUrl = new URL(window.location)
    newUrl.searchParams.delete('date')
    newUrl.searchParams.set('period', period)

    window.location.href = newUrl.toString()
  }

  // Día que muestra la pantalla, tal como lo calculó el servidor ("YYYY-MM-DD"),
  // como fecha local para que getDate/setDate no crucen de día por el huso.
  displayedDate() {
    const [year, month, day] = this.currentDateValue.split('-').map(Number)
    return new Date(year, month - 1, day)
  }

  showLoading() {
    if (this.hasOverlayTarget) {
      this.overlayTarget.classList.remove('d-none')
    }
  }

  hideLoading() {
    if (this.hasOverlayTarget) {
      this.overlayTarget.classList.add('d-none')
    }
  }

  keepSpinnerUntilRedirect() {
    const handleBeforeUnload = () => {
      this.hideLoading()
      this.isLoading = false
    }

    window.addEventListener('beforeunload', handleBeforeUnload)

    setTimeout(() => {
      window.removeEventListener('beforeunload', handleBeforeUnload)
      this.hideLoading()
      this.isLoading = false
    }, 10000)
  }
}
